export enum REPORT_TYPE {
    AUDIT = 'AUDIT',
    DEVICES='DEVICES',
    CARD_ACCESS='CARD_ACCESS',
    PERIODIC_REVIEW='PERIODIC_REVIEW',
    SMS='SMS'
}